export const calculateInvoicesTotal = invoices =>
  invoices.reduce((acc, invoice) => acc + invoice.remainingAmount, 0)
